<template>
  <div class="account-employer-profile-edit d-flex">
    <AccountProfileForm :key="updateKey" />
    <div :style="mdOrDown ? '' : 'flex-basis: 46rem; padding-left: 1rem'">
      <SignInSide
        v-if="sideHint"
        :preview-img-url="sideHint.image"
        :custom-title="sideHint.title"
        :custom-description="sideHint.text"
        :use-play-btn="false"
        :is-fixed-condition="mdOrDown"
      />
    </div>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash';
  import { mapGetters, mapActions } from 'vuex';
  import windowSizeMixin from '../../../mixins/windowSizeMixin';
  import AccountProfileForm from '@/components/AccountProfileForm'

  export default {
    name: 'AccountEmployerProfileEditPage',
    components: {
      AccountProfileForm,
      SignInSide: () => import('../../../components/SignIn/SignInSide'),
    },
    mixins: [windowSizeMixin],
    data() {
      return {
        updateKey: 0,
        unsubscribeProfileUpdates: null,
        comparingEmployerProfile: null,
        sideHint: null,
      };
    },
    computed: {
      ...mapGetters('user', [
        'employerProfile',
      ]),
    },
    created() {
      this.loadHints();
    },
    mounted() {
      this.comparingEmployerProfile = cloneDeep(this.employerProfile);

      this.unsubscribeProfileUpdates = this.$store.subscribe((mutation) => {
        if (mutation.type === 'user/updateEmployerProfile') {
          this.updateProfileFormCard();
        }
      });
    },
    beforeDestroy() {
      this.unsubscribeProfileUpdates();
    },
    methods: {
      ...mapActions([
        'getHints',
      ]),

      async loadHints() {
        const hints = await this.getHints({ group: 'employer_profile' }).catch(() => {});
        if (hints) {
          this.sideHint = hints[0];
        }
      },
      updateProfileFormCard() {
        const newProfile = JSON.stringify(cloneDeep(this.employerProfile));
        if (JSON.stringify(this.comparingEmployerProfile) !== newProfile) {
          this.updateKey++;
        }
        this.comparingEmployerProfile = cloneDeep(this.employerProfile);
      },
    },
  }
</script>
